




















import { Component as VueComponent } from "vue";
import { Component, Mixins, Prop } from "vue-property-decorator";
import { TranslateResult } from "vue-i18n";
import CProdInjectorMixin from "@/mixins/cProdInjectorMixin";
import i18n from "@/i18n";
import _ from "@/boot/lodash";

interface INotice {
  icon: string;
  type: string;
  priority: number;
  notice: TranslateResult | string;
  if: () => boolean;
  action?: VueComponent;
}

@Component
export default class CProdNoticesComp extends Mixins(CProdInjectorMixin) {
  // Props
  @Prop({
    required: true,
    validator: tag =>
      ["u-aside", "u-section-box", "u-contextualise"].includes(tag)
  })
  public readonly tag!: string;

  // Computed

  public get severity() {
    return {
      info: {
        icon: "info-circle",
        type: "is-info",
        priority: 4
      },
      caution: {
        icon: "info-circle",
        type: "is-caution",
        priority: 3
      },
      warning: {
        icon: "exclamation-circle",
        type: "is-warning",
        priority: 2
      },
      danger: {
        icon: "exclamation-triangle",
        type: "is-danger",
        priority: 1
      }
    };
  }

  public get allNotices(): INotice[] {
    return [
      {
        ...this.severity.info,
        notice: i18n.t("_sentence.delegates.delegated_object_msg", {
          objectType: this.cProdData.entity
        }),
        if: () => this.cProdData.isDelegatedAccess
      }
    ];
  }

  public get activeNotices() {
    return _.sortBy(
      _.filter(this.allNotices, notice => notice.if()),
      ["priority"]
    );
  }

  public get isVisible() {
    return !!this.activeNotices.length;
  }
}
